import { useRef, useImperativeHandle, useEffect } from 'react';
import TableInstanceApiSingleton from '../manager/TableInstanceApiSingleton';
import useUpdatedRef from '../../../utils/react/useUpdatedRef';

const useInitTableInstanceApi = (props) => {
    const { elementId, hotTableInstanceRef, cellEditorRef, tableOperations } = props;

    const tableOperationsRef = useUpdatedRef(tableOperations);
    const tableInstanceApiRef = useRef(null);

    // Expose methods to HotTableManager via imperative handle
    useImperativeHandle(
        tableInstanceApiRef,
        () => ({
            hotTableInstanceRef,
            cellEditorRef,
            tableOperationsRef,
        }),
        [hotTableInstanceRef, tableOperationsRef, cellEditorRef],
    );

    useEffect(() => {
        TableInstanceApiSingleton.add(elementId, tableInstanceApiRef.current);

        return () => {
            TableInstanceApiSingleton.remove(elementId);
        };
    }, []);
};

export default useInitTableInstanceApi;
